import React from "react";
import { Box, Stack } from "@mui/material";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import TopBar from "../../../../../component/TopBar";
import { tokens } from "../../../../../theme";

const ROOT = "/app/settings/payroll";
const TABS = [
  { label: "Dashboard", to: ROOT, exact: true },
  { label: "Runs", to: `${ROOT}/runs` },
  { label: "Salary Structures", to: `${ROOT}/structures` },
  { label: "Salary Components", to: `${ROOT}/components` },
  { label: "Statutory", to: `${ROOT}/statutory` },
  { label: "Reports", to: `${ROOT}/reports` },
  { label: "Payslips", to: `${ROOT}/payslips` },
  { label: "Queries", to: `${ROOT}/queries` },
];

const PayrollLayout = () => {
  const { pathname } = useLocation();
  const isActive = (t) => {
    if (t.exact) return pathname === ROOT || pathname === `${ROOT}/` || pathname === `${ROOT}/dashboard`;
    return pathname.startsWith(t.to);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <TopBar MainHeading={"Payroll"} breadcrumbs={[{ label: "Payroll", href: "" }]} />
      <Stack direction="row" spacing={3.5} sx={{ borderBottom: `1px solid ${tokens.border}`, mb: "1.5rem", px: "0.25rem", flexWrap: "wrap" }}>
        {TABS.map((t) => {
          const active = isActive(t);
          return (
            <NavLink key={t.to} to={t.to} style={{ textDecoration: "none" }}>
              <Box sx={{
                pb: "0.75rem", fontSize: "0.875rem", fontWeight: active ? 600 : 400,
                color: active ? tokens.text : tokens.primary,
                borderBottom: active ? `2px solid ${tokens.primary}` : "2px solid transparent",
                mb: "-1px", transition: "color 120ms cubic-bezier(0.2, 0, 0.2, 1)",
              }}>{t.label}</Box>
            </NavLink>
          );
        })}
      </Stack>
      <Outlet />
    </Box>
  );
};

export default PayrollLayout;
